export enum ReasonTypeEnum {
    healthcare = "healthcare",
    education = "education",
    social_assistance = "social_assistance",
    cultural_activities = "cultural_activities",
    sports = "sports",
    financial_operations = "financial_operations",
    real_estate_exemptions = "real_estate_exemptions",
    exports = "exports",
    intracommunity_deliveries = "intracommunity_deliveries",
}


export class ReasonType {
    constructor(
        public readonly id: ReasonTypeEnum,
        public readonly label: string,
    ) { }
}